<template>
	<v-menu
		v-model="showDatepicker"
		:close-on-content-click="false"
		transition="slide-y-transition"
		min-width="auto"
		max-width="300"
		nudge-top="-100"
		top
		offset-overflow
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				light
				class="little-select shadow mt-2 bg-white"
				:class="{ 'select-btn': isSecondary, 'text-error': error }"
				height="28"
				@click="showDatepicker = !showDatepicker"
				v-bind="attrs"
				v-on="on"
				v-if="!isIcon"
				:disabled="disabled"
				style="border: none !important"
			>
				{{ text || emptyText }} <v-icon>mdi-chevron-down</v-icon>
			</v-btn>

			<v-btn
				color="transparent"
				icon
				@click="showDatepicker = !showDatepicker"
				v-bind="attrs"
				v-on="on"
				v-else
				:disabled="disabled"
			>
				<slot></slot>
			</v-btn>
		</template>
		<div class="d-flex flex-column bg-white">
			<v-date-picker
				locale="pl-pl"
				:min="$moment().format('YYYY-MM-DD')"
				v-model="fields.date"
			>
				<div v-show="fields.date" class="mx-3 d-flex flex-column">
					<v-switch
						v-model="fields.time"
						color="accent"
						label="Chcę ustalić godzinę"
					></v-switch>
					<v-row v-if="fields.time" class="mb-5">
						<v-col cols="7"> Godzina zakończenia </v-col>
						<v-col
							cols="5"
							class="d-flex align-items-center justify-content-right"
						>
							<input
								v-model.lazy="fields.time"
								type="time"
								name="time"
							/>
						</v-col>
					</v-row>
				</div>
			</v-date-picker>
			<div class="d-flex flex-row pa-2 justify-content-center">
				<v-btn
					text
					@click="
						(fields.date = null),
							(fields.time = null),
							(showDatepicker = false)
					"
					class="mr-2"
					>Wyczyść</v-btn
				>
				<v-btn text @click="showDatepicker = false">OK</v-btn>
			</div>
		</div>
	</v-menu>
</template>

<script>
export default {
	props: {
		date: null,
		isSecondary: { type: Boolean, default: false },
		isIcon: { type: Boolean, default: false },
		emptyText: {
			type: String,
			default: "Bez limitu",
		},
		error: {
			type: Boolean,
			default: false,
		},
		disabled: Boolean,
	},
	data() {
		return {
			showDatepicker: false,
			fields: {
				date: null,
				time: null,
			},
		};
	},
	watch: {
		final: function () {
			this.$emit("selected", this.final);
		},
	},
	computed: {
		final() {
			if (this.fields.date) {
				let d = `${this.fields.date}`;
				if (this.fields.time && this.fields.time !== true) {
					d += ` ${this.fields.time}`;
					return this.$moment(d);
				} else {
					// d += `T23:59:59.000Z`;
					return this.$moment(d).endOf('day');
				}
			}
			return null;
		},
		text() {
			if (this.fields.date) {
				let d = `${this.fields.date}`;
				if (this.fields.time && this.fields.time !== true) {
					d += ` ${this.fields.time}`;
					return this.$moment(d).local().format("LLL");
				} else {
					return this.$moment(d).local().format("LL");
				}
			}
			return "";
		},
	},
	created() {
		if (this.date) {
			console.log("THIS DATE", this.date);
			this.fields.date = this.$moment(this.date).format("YYYY-MM-DD");
			if (this.$moment(this.date).format("HH:mm") != "00:00") {
				this.fields.time = this.$moment(this.date).format("HH:mm");
			} else {
				this.fields.time = null;
			}
		}
	},
};
</script>
